import { render, staticRenderFns } from "./OmieIntegrationTab.vue?vue&type=template&id=3cf2f460&"
import script from "./OmieIntegrationTab.vue?vue&type=script&lang=js&"
export * from "./OmieIntegrationTab.vue?vue&type=script&lang=js&"
import style0 from "./OmieIntegrationTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports